import { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Preloader } from "./components/Preloader";
import { CustomCursor } from "./components/CustomCursor";
import { ScrollProgress } from "./components/ScrollProgress";
import { FloatingParticles } from "./components/FloatingParticles";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { ServicesSection } from "./components/ServicesSection";
import { StatsSection } from "./components/StatsSection";
import { AboutSection } from "./components/AboutSection";
import { CaseStudiesSection } from "./components/CaseStudiesSection";
import { PartnersSection } from "./components/PartnersSection";
import { WhyChooseSection } from "./components/WhyChooseSection";
import { FAQSection } from "./components/FAQSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";

const Home = () => {
  return (
    <div style={{ background: "#0F1225", minHeight: "100vh", position: "relative" }}>
      <Header />
      <HeroSection />
      <ServicesSection />
      <StatsSection />
      <AboutSection />
      <CaseStudiesSection />
      <PartnersSection />
      <WhyChooseSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="App">
      <Preloader onComplete={() => setLoaded(true)} />
      {loaded && (
        <>
          <CustomCursor />
          <ScrollProgress />
          <FloatingParticles />
        </>
      )}
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#171B36",
            color: "#F0F0FF",
            border: "1px solid rgba(123,104,238,0.2)",
            fontFamily: "'Kode Mono', monospace",
            borderRadius: "8px",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
